import React from 'react';

/**
 * 📊 統計圖標組件
 * 用於頂部狀態欄的圖標顯示
 */
const StatIcon = ({ type, size = 24, className = '' }) => {
  const iconConfig = {
    total: '🔔',
    combo: '⚡',
    record: '🏆',
    days: '📅'
  };

  const icon = iconConfig[type];
  if (!icon) return null;

  return (
    <span 
      className={className}
      style={{ 
        fontSize: `${size}px`, 
        lineHeight: 1,
        display: 'inline-block'
      }}
      role="img"
      aria-label={type}
    >
      {icon}
    </span>
  );
};

export default StatIcon;